import site from './site.json'
import type { RouteLocationNormalized } from 'vue-router'

export { site }

export function applyPageSeo(route: RouteLocationNormalized) {
  const page = site.pages.find((item) => item.path === route.path)
  const title = page?.title || `${String(route.meta.title || '页面')}｜YDC宜得仓`
  document.title = title
  document.documentElement.lang = 'zh-CN'
  const setMeta = (name: string, content: string) => {
    let tag = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
    if (!tag) {
      tag = document.createElement('meta')
      tag.name = name
      document.head.appendChild(tag)
    }
    tag.content = content
  }
  setMeta('description', page?.description || 'YDC宜得仓官方网站。')
  // 仅明确公开的栏目进入索引，账户、支付及受套餐限制的详情保持 noindex。
  setMeta('robots', page ? 'index,follow' : 'noindex,follow')
  let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (page) {
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = site.origin + page.path
  } else {
    canonical?.remove()
  }
  document.getElementById('store-structured-data')?.remove()
  if (route.path === '/about') {
    const script = document.createElement('script')
    script.id = 'store-structured-data'
    script.type = 'application/ld+json'
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FurnitureStore',
      '@id': `${site.origin}/#store`,
      name: site.store.name,
      url: site.origin + '/',
      description: page?.description,
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'CN',
        addressRegion: '四川省',
        addressLocality: '成都市双流区',
        streetAddress: '物联大道111号4栋3楼'
      }
      // 未确认营业星期、电话、坐标，不生成推测值。
    })
    document.head.appendChild(script)
  }
}
